/**
 * Links Externos - Grupo D12 Hub
 * Centralizador de URLs externas usadas no sistema
 */

/**
 * Tutorial em vídeo: Como configurar e renovar token do Meta Ads API
 * Hospedado no ClickUp
 * @updated 2025-09-30
 */
export const META_ADS_TUTORIAL_URL = 'https://sharing.clickup.com/clip/p/t31134544/6582f8b5-104a-457e-8a97-1617913c9808/6582f8b5-104a-457e-8a97-1617913c9808.webm?filename=screen-recording-2025-09-30-23:22.webm';
